// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Organizations_container__OG5Fv {
  background-color: #f5fafa;
  width: 100%;
  height: calc(100vh - 97px);
  overflow-y: auto;
  border-radius: 0 0 0 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding-bottom: 1rem;
}

.Organizations_header__VUIj7 {
  width: 95%;
  background-color: white;
  border-radius: 8px;
}

.Organizations_headerContent__LOa7S {
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Organizations_orgBtn__DSy8s,
.Organizations_companyBtn__jvfm4 {
  background-color: #3082f6;
  border: none;
  padding: 0 16px;
  border-radius: 12px;
  height: 44px;
  color: white;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.Organizations_table__d6Ql2 {
  width: 95%;
  background-color: white;
  padding-bottom: 1rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Organizations_tableHeader__79sfx {
  padding: 12px 20px;
  height: 20px;
  background-color: #3082f6;
  width: 90%;
  border-radius: 0 0 8px 8px;
  display: flex;
  justify-content: space-between;
  color: white;
}

.Organizations_tableHeader__79sfx > div {
  width: 120px;
  display: inline-block;
  white-space: normal;
  word-wrap: break-word;
}

.Organizations_tableHeader__79sfx > div:nth-child(4),
.Organizations_tableHeader__79sfx > div:nth-child(5) {
  text-align: center;
}

.Organizations_notificationsDiv__vH2cd {
  width: 400px;
  border-radius: 8px;
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Organizations_errorMsg__WJmRy {
  max-width: 500px;
  background-color: red;
  font-weight: 500;
  padding: 1rem;
  border-radius: 8px;
}

.Organizations_buttons__-HOfI,
.Organizations_toggleButtons__QMKmp {
  display: flex;
  gap: 20px;
}

.Organizations_toggleOrgBtn__w--qT,
.Organizations_toggleCompaniesBtn__fnV1w {
  padding: 6px 12px;
  border-radius: 8px;
  height: 44px;
  background-color: transparent;
  border: 1px solid #79818c1f;
  color: #1b1f3ba6;
  line-height: 24px;
  cursor: pointer;
}

.Organizations_active__VXNHq {
  background-color: #3082f6;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  height: 44px;
  line-height: 24px;
}

h1 {
  width: 78%;
  height: 100px;
  background-color: red;
}
`, "",{"version":3,"sources":["webpack://./src/components/organizations/Organizations.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,qBAAqB;AACvB","sourcesContent":[".container {\n  background-color: #f5fafa;\n  width: 100%;\n  height: calc(100vh - 97px);\n  overflow-y: auto;\n  border-radius: 0 0 0 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  padding-bottom: 1rem;\n}\n\n.header {\n  width: 95%;\n  background-color: white;\n  border-radius: 8px;\n}\n\n.headerContent {\n  padding: 8px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.orgBtn,\n.companyBtn {\n  background-color: #3082f6;\n  border: none;\n  padding: 0 16px;\n  border-radius: 12px;\n  height: 44px;\n  color: white;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.table {\n  width: 95%;\n  background-color: white;\n  padding-bottom: 1rem;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.tableHeader {\n  padding: 12px 20px;\n  height: 20px;\n  background-color: #3082f6;\n  width: 90%;\n  border-radius: 0 0 8px 8px;\n  display: flex;\n  justify-content: space-between;\n  color: white;\n}\n\n.tableHeader > div {\n  width: 120px;\n  display: inline-block;\n  white-space: normal;\n  word-wrap: break-word;\n}\n\n.tableHeader > div:nth-child(4),\n.tableHeader > div:nth-child(5) {\n  text-align: center;\n}\n\n.notificationsDiv {\n  width: 400px;\n  border-radius: 8px;\n  margin-top: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.errorMsg {\n  max-width: 500px;\n  background-color: red;\n  font-weight: 500;\n  padding: 1rem;\n  border-radius: 8px;\n}\n\n.buttons,\n.toggleButtons {\n  display: flex;\n  gap: 20px;\n}\n\n.toggleOrgBtn,\n.toggleCompaniesBtn {\n  padding: 6px 12px;\n  border-radius: 8px;\n  height: 44px;\n  background-color: transparent;\n  border: 1px solid #79818c1f;\n  color: #1b1f3ba6;\n  line-height: 24px;\n  cursor: pointer;\n}\n\n.active {\n  background-color: #3082f6;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 8px;\n  height: 44px;\n  line-height: 24px;\n}\n\nh1 {\n  width: 78%;\n  height: 100px;\n  background-color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Organizations_container__OG5Fv`,
	"header": `Organizations_header__VUIj7`,
	"headerContent": `Organizations_headerContent__LOa7S`,
	"orgBtn": `Organizations_orgBtn__DSy8s`,
	"companyBtn": `Organizations_companyBtn__jvfm4`,
	"table": `Organizations_table__d6Ql2`,
	"tableHeader": `Organizations_tableHeader__79sfx`,
	"notificationsDiv": `Organizations_notificationsDiv__vH2cd`,
	"errorMsg": `Organizations_errorMsg__WJmRy`,
	"buttons": `Organizations_buttons__-HOfI`,
	"toggleButtons": `Organizations_toggleButtons__QMKmp`,
	"toggleOrgBtn": `Organizations_toggleOrgBtn__w--qT`,
	"toggleCompaniesBtn": `Organizations_toggleCompaniesBtn__fnV1w`,
	"active": `Organizations_active__VXNHq`
};
export default ___CSS_LOADER_EXPORT___;
